<template>
  <div>
    <button
        class="lg:hidden flex items-center p-2 rounded-lg hover:text-grey primary-bg menu-toggle"
        @click="showMenu = !showMenu"
        :aria-label="showMenu ? 'Close menu' : 'Open menu'"
        :aria-expanded="showMenu">
      <v-icon v-if="!showMenu" name="md-menu"></v-icon>
      <v-icon v-if="showMenu" name="ri-close-fill"></v-icon>
    </button>
    <Sidebar v-model:visible="showMenu" class="w-full menu-sidebar" :base-z-index="baseZIndex">
      <div class="">
        <slot></slot>
      </div>
    </Sidebar>
  </div>
</template>

<script lang="ts">
import {defineComponent} from "vue";
import Sidebar from 'primevue/sidebar';

export default defineComponent({
  components: {
    Sidebar,
  },
  props: {
    // Layouts with a fixed or sticky header above PrimeVue's modal tier pass 1300.
    baseZIndex: {
      type: Number,
      default: 0,
    },
  },
  mounted() {
    if (this.$slots.default) {
      this.$slots.default().forEach((slot: any) => {
        if (slot.props.class.indexOf('hidden') > -1) {
          slot.props.class = 'flex flex-col';
        }
      })
    }
  },
  data() {
    return {
      showMenu: false,
    }
  },
})
</script>

<style>
.menu-sidebar {
  width: 100% !important;
}
</style>